// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"49968da1","25":"4d475eb0","100":"6d3b4ee4","787":"d6392bef"}[chunkId] + ".chunk.js";
};